"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Link = _interopRequireDefault(require("../../../Link/Link"));
var _Svg = _interopRequireDefault(require("../../../Svg/Svg"));
var _constants = require("../../../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var DesktopLink = function DesktopLink(_ref) {
  var link = _ref.link,
    active = _ref.active;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "custom-dropdown desktop--link d8-u-color-black d8-u-ls-sm ".concat(active ? 'menu-active' : null)
  }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    className: "d8-u-color-black flex items-center",
    href: link.href,
    external: link.externalLink
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "margin-none d8-u-font-secondary d8-u-text-uppercase d8-u-font-size-base"
  }, link.label), link.icon && /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: link.icon,
    className: "margin-left-sm",
    fill: _constants.COLORS.BLACK
  })), link.nested && /*#__PURE__*/_react["default"].createElement("div", {
    className: "dropdown text-component d8-u-radius-md padding-bottom-sm"
  }, link.nested.map(function (link) {
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: JSON.stringify(link)
    }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      href: link.href,
      className: "d8-u-radius-md ".concat(link.bgColor),
      external: link.externalLink
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-center"
    }, link.icon && /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
      name: link.icon,
      className: "margin-left-xxs icon--sm",
      fill: _constants.COLORS.BLACK
    }), /*#__PURE__*/_react["default"].createElement("div", {
      dangerouslySetInnerHTML: {
        __html: link.label
      }
    }))), link.hasHr && /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: '80%',
        height: '1px',
        backgroundColor: 'var(--color-contrast-low)',
        margin: 'auto'
      }
    }));
  })));
};
DesktopLink.propTypes = {
  link: _propTypes["default"].object
};
var _default = exports["default"] = DesktopLink;